// Frontend JavaScript for shortcode preview block
// Currently empty as no frontend JavaScript functionality is needed 